import { getTranslation } from "../../utils/functions";
import { GENDER_ENUM_TRANSLATIONS, GENDER_OPTIONS } from "./constant";

export const getTranslatedGenderOptions = () => {
    return GENDER_OPTIONS.map(option => ({
      label: getTranslation(GENDER_ENUM_TRANSLATIONS[option.value]),
      value: option.value,
    }));
  };